interface Props {
  text: string
}

export function SectionLabel({ text }: Props) {
  return (
    <div className="gc-section-label">
      <div className="gc-section-label__rule" />
      <span className="gc-section-label__text">{text}</span>
      <div className="gc-section-label__rule" />
    </div>
  )
}
